import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import Input from "../Input";
import { ReactComponent as At } from "../../assets/svg/at.svg";
import { ReactComponent as LockSVG } from "../../assets/svg/lock.svg";
import KRGlue from "@lyracom/embedded-form-glue";
import axios from "axios";
import Spinner from "../Spinner";
import { isValidEmail } from "../../helpers/validators";
import NotificationError from "./NotificationError";
import { v4 as uuidv4 } from "uuid";
import ModalLoading from "./ModalLoading";

const FormCheckout = ({
  courseId,
  phone,
  email = undefined,
  price = undefined,
  onClose,
  onSubmitSuccess = () => {},
  orderId = uuidv4(),
}) => {
  const [modal, setModal] = useState(undefined);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    if (price === undefined) return;

    const endpoint = "https://static.micuentaweb.pe";
    const publicKey =
      "22347224:publickey_fWiC8XgTtKgM54qR4CJLXnut9vvAn7vvpfBvR6wlXKf2n";
    // const publicKey =
    //   "22347224:testpublickey_RGNK5CX0aAZtdEoEVeniPuq7qHQYJNTcdtXuCkXSgW4Xg";
    let formToken = "";

    axios
      .post(
        `https://us-central1-awesome-radi-languages.cloudfunctions.net/createPayment`,
        {
          paymentConf: {
            amount: price * 100,
            currency: "USD",
            customer: { email: email },
            orderId: orderId,
          },
        }
      )
      .then((resp) => {
        formToken = resp.data;
        return KRGlue.loadLibrary(endpoint, publicKey);
      })
      .then(({ KR }) =>
        KR.setFormConfig({
          formToken: formToken,
          "kr-language": "es-ES",
        })
      )

      .then(({ KR }) =>
        KR.onSubmit((paymentData) => {
          setIsProcessing(true);
          axios
            .post(
              `https://us-central1-awesome-radi-languages.cloudfunctions.net/validatePayment`,
              paymentData
            )
            .then(async (response) => {
              if (response.status === 200)
                return axios
                  .post(
                    `https://us-central1-awesome-radi-languages.cloudfunctions.net/activateCourse`,
                    {
                      email,
                      phone,
                      courseId,
                    }
                  )
                  .then((response) => {
                    if (response.status === 200) onSubmitSuccess(response.data);
                    else
                      setModal({
                        error: true,
                        errorMessage: `Se efectuó el pago, pero no se pudo crear la cuenta.\n\nComunícate al número +51 975 400 190 o al correo RaDi-languages@t-online.de para solucionar tu caso lo más antes posible. Indica tu código de transacción.\n\nTu código de transacción es: ${orderId}`,
                      });
                  });
              else
                setModal({
                  error: true,
                  errorMessage: `El hash de la transacción no es correcta.\n\nSe efectuó el pago, pero no se pudo crear la cuenta.\n\nComunícate al número +51 975 400 190 o al correo RaDi-languages@t-online.de para solucionar tu caso lo más antes posible. Indica tu código de transacción.\n\nTu código de transacción es: ${orderId}`,
                });
            })
            .finally(() => {
              setIsProcessing(false);
            });
          return false;
        })
      )
      .then(({ KR }) => {
        setIsLoading(false);
        return KR.attachForm("#paymentForm");
      })
      .then(({ KR, result }) => KR.showForm(result.formId))
      .catch((error) => setModal({ error: true, errorMessage: error }));
  }, [price, orderId]);

  return (
    <>
      <Container>
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Form>
              <FormPayment>
                <div id="paymentForm">
                  <div className="kr-embedded">
                    <div className="kr-pan" kr-tab-order="1"></div>
                    <div className="kr-expiry" kr-tab-order="2"></div>
                    <div className="kr-security-code" kr-tab-order="3"></div>

                    <div className="kr-form-error"></div>
                    <button className="kr-payment-button">
                      Pagar ${price.toFixed(2)}
                    </button>
                  </div>
                </div>
              </FormPayment>
            </Form>
          </>
        )}
        {!isLoading && (
          <Footer>
            <LockIcon as={LockSVG} />
            <FooterLabel>Pago 100% seguro, protegemos tus datos</FooterLabel>
          </Footer>
        )}
      </Container>
      <NotificationError
        isOpen={modal?.error === true}
        errorMessage={modal?.errorMessage}
        onClose={() => {
          setModal(undefined);
        }}
      />
      <ModalLoading isOpen={isProcessing} />
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .kr-embedded .kr-pan,
  .kr-embedded .kr-field.kr-text,
  .kr-embedded .kr-field.kr-checkbox,
  .kr-embedded .kr-expiry,
  .kr-embedded .kr-security-code,
  .kr-embedded .kr-identity-document-number,
  .kr-embedded .kr-card-holder-name,
  .kr-embedded .kr-card-holder-mail,
  .kr-embedded .kr-identity-document-type,
  .kr-embedded .kr-installment-number,
  .kr-embedded .kr-first-installment-delay,
  .kr-embedded > .kr-field-wrapper {
    border-radius: 5px !important;
    border-color: rgba(0, 0, 0, 0.2) !important;
  }

  .kr-embedded .kr-payment-button {
    background-color: #226dd4 !important;
    border-radius: 10px !important;
  }

  .kr-form-error {
    border-radius: 5px;
  }
`;

const Form = styled.div``;

const FormPayment = styled.div`
  margin-top: 16px;
`;

const InputStyled = styled(Input)`
  border-radius: 5px;
`;

const InputIcon = styled.div`
  padding: 8px 10px;
  min-width: 18px;
  min-height: 18px;
  width: 18px;
  height: 18px;
  margin: auto 0;
  fill: rgba(0, 0, 0, 0.5);

  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`;

const Footer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

const LockIcon = styled.div`
  min-width: 15px;
  min-height: 15px;
  width: 15px;
  height: 15px;
  margin: 5px;
`;

const FooterLabel = styled.div`
  font-size: 0.85em;
`;

export default FormCheckout;
